(function () {
  const RECOMMENDATIONS_SECTION_ID = 'cart-drawer-upsell-recommendations';

  async function loadCartDrawerUpsellRecommendations(element) {
    const productId = element.getAttribute('data-product-id');
    const displayLimit = Number.parseInt(element.getAttribute('data-limit') || '4', 10);
    const requestLimit = Math.min(10, Math.max(displayLimit, displayLimit * 2));
    const limit = Number.isNaN(displayLimit) ? 4 : requestLimit;
    const intent = element.getAttribute('data-intent') || 'related';
    const heading = element.getAttribute('data-upsell-heading');

    if (!productId || element.dataset.loading === 'true') {
      return;
    }

    element.dataset.loading = 'true';

    const url = `${window.Shopify?.routes?.root || '/'}recommendations/products?product_id=${productId}&limit=${limit}&section_id=${RECOMMENDATIONS_SECTION_ID}&intent=${intent}`;

    try {
      const response = await fetch(url);

      if (!response.ok) {
        element.remove();
        return;
      }

      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const sectionRoot =
        doc.querySelector('.shopify-section--cart-drawer-upsell-recommendations') ||
        doc.querySelector(`[id*="${RECOMMENDATIONS_SECTION_ID}"]`);
      const content = sectionRoot?.querySelector('[data-cart-drawer-upsell-content]');

      if (!content || !content.innerHTML.trim()) {
        element.remove();
        return;
      }

      const wrapper = document.createElement('div');
      wrapper.className = 'cart-drawer__upsell';

      if (heading) {
        const headingElement = document.createElement('p');
        headingElement.className = 'cart-drawer__upsell-heading';
        headingElement.textContent = heading;
        wrapper.appendChild(headingElement);
      }

      const importedContent = document.importNode(content, true);
      const cards = importedContent.querySelectorAll('.cart-drawer-upsell-card');

      cards.forEach((card, index) => {
        if (index >= displayLimit) {
          card.remove();
        }
      });

      if (!importedContent.querySelector('.cart-drawer-upsell-card')) {
        element.remove();
        return;
      }

      wrapper.appendChild(importedContent);
      element.replaceChildren(wrapper);
      element.hidden = false;
    } catch (_error) {
      element.remove();
    }
  }

  function getCartDrawerUpsellRoots(root = document) {
    const cartDrawer = root.getElementById?.('cart-drawer') || document.getElementById('cart-drawer');

    return cartDrawer ? [cartDrawer, root] : [root];
  }

  function initCartDrawerUpsellRecommendations(root = document) {
    const seen = new Set();

    getCartDrawerUpsellRoots(root).forEach((scope) => {
      scope.querySelectorAll('.cart-drawer__upsell-recommendations[data-product-id]').forEach((element) => {
        if (seen.has(element) || element.childElementCount > 0) {
          return;
        }

        seen.add(element);
        delete element.dataset.loading;
        loadCartDrawerUpsellRecommendations(element);
      });
    });
  }

  if (window.__cartDrawerUpsellInit) {
    return;
  }

  window.__cartDrawerUpsellInit = true;

  document.addEventListener('cart-drawer:refreshed', () => {
    initCartDrawerUpsellRecommendations(document.getElementById('cart-drawer') || document);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCartDrawerUpsellRecommendations());
  } else {
    initCartDrawerUpsellRecommendations();
  }
})();
